// DS: i1.5
// this icon looks to be outdated, see 24x24 version
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const BirthdayCake: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="0"
      height="0"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g>
        <path d="M12.2437 2.0758C13.0562 3.08652 14.1123 4.40045 13.0562 5.81546C12.4875 6.52296 11.5938 6.62403 10.9438 5.81546C9.88767 4.40045 10.9438 3.08652 11.7563 2.0758C11.9188 1.97473 12.0812 1.97473 12.2437 2.0758Z" />
        <path d="M13 8H11V11H4.84091C3.81818 11 3 11.783 3 12.8747V13.4725C3.68182 13.6284 3.95455 13.8624 4.43182 14.3303C5.38636 15.266 6.27273 15.266 7.15909 14.3303C8.31818 13.1606 9.47727 13.1606 10.6364 14.3303C11.5909 15.266 12.4091 15.266 13.3636 14.3303C14.5227 13.1606 15.6818 13.1606 16.8409 14.3303C17.7955 15.266 18.6136 15.266 19.5682 14.3303C20.0455 13.8624 20.3864 13.6284 21 13.4725V12.8747C21 11.783 20.25 11 19.2273 11H13V8Z" />
        <path d="M7.56818 16.2604C6.40909 17.5972 5.25 17.5972 4.09091 16.2604L4.01456 16.177C3.66241 15.7917 3.51007 15.625 3 15.4583V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V15.4583C20.5227 15.6366 20.3182 15.8148 19.9091 16.2604C18.75 17.5972 17.6591 17.5972 16.5 16.2604C15.5455 15.191 14.6591 15.191 13.7727 16.2604C12.6136 17.5972 11.4545 17.5972 10.2955 16.2604C9.34091 15.191 8.52273 15.191 7.56818 16.2604Z" />
      </g>
    </svg>
  </IconWrap>
);
BirthdayCake.displayName = 'BirthdayCake';

export default BirthdayCake;
